/**
 * tdesign v1.6.6
 * (c) 2023 tdesign
 * @license MIT
 */

import { h as helper } from '../_chunks/dep-1461d230.js';
import _typeof from '@babel/runtime/helpers/typeof';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { defineComponent, ref } from '@vue/composition-api';
import { FilterIcon } from 'tdesign-icons-vue';
import isEmpty from 'lodash/isEmpty';
import lowerFirst from 'lodash/lowerFirst';
import { Popup } from '../popup/index.js';
import { CheckboxGroup } from '../checkbox/index.js';
import { RadioGroup } from '../radio/index.js';
import { Input } from '../input/index.js';
import { Button } from '../button/index.js';
import { useTNodeDefault } from '../hooks/tnode.js';
import { useGlobalIcon } from '../hooks/useGlobalIcon.js';
import { useConfig } from '../config-provider/useConfig.js';
import '../_common/js/log/index.js';
import log from '../_common/js/log/log.js';
import '../popup/popup.js';
import '@popperjs/core';
import 'lodash/debounce';
import '../utils/dom.js';
import 'vue';
import 'raf';
import 'lodash/isString';
import '../utils/easing.js';
import '../utils/render-tnode.js';
import 'lodash/camelCase';
import 'lodash/kebabCase';
import '../utils/helper.js';
import '@babel/runtime/helpers/objectWithoutProperties';
import '@babel/runtime/helpers/slicedToArray';
import '../_common/js/utils/set-style.js';
import '../popup/props.js';
import '../popup/container.js';
import 'lodash/isFunction';
import '../config-provider/config-receiver.js';
import 'lodash/mergeWith';
import '../config-provider/context.js';
import 'lodash/merge';
import '../_common/js/global-config/default-config.js';
import '../_common/js/global-config/locale/zh_CN.js';
import '../_chunks/dep-fdafdce0.js';
import 'dayjs';
import '../_chunks/dep-9849f16c.js';
import '../config-provider/type.js';
import '../utils/mixins.js';
import '../utils/event.js';
import '../popup/utils.js';
import '../utils/map-props.js';
import '../utils/withInstall.js';
import 'lodash/capitalize';
import './style/css.js';
import '../popup/type.js';
import '../popup/plugin.js';
import '../checkbox/group.js';
import '@babel/runtime/helpers/toConsumableArray';
import 'lodash/intersection';
import 'lodash/isObject';
import 'lodash/isUndefined';
import '../checkbox/checkbox.js';
import '../checkbox/props.js';
import '../hooks/index.js';
import '../hooks/slots.js';
import 'lodash/isArray';
import '../hooks/useCommonClassName.js';
import '../hooks/useConfig.js';
import '../hooks/useDefaultValue.js';
import '../hooks/useDestroyOnClose.js';
import '../hooks/useElementLazyRender.js';
import '../_common/js/utils/observe.js';
import '../hooks/useFormDisabled.js';
import '../hooks/useLazyLoad.js';
import '../hooks/useResizeObserver.js';
import '../hooks/useVirtualScrollNew.js';
import '../hooks/useVModel.js';
import '../hooks/useImagePreviewUrl.js';
import '../_common/js/upload/utils.js';
import '../checkbox/constants.js';
import '../checkbox/store.js';
import '@babel/runtime/helpers/classCallCheck';
import '@babel/runtime/helpers/createClass';
import '../checkbox/hooks/useKeyboardEvent.js';
import '../checkbox/checkbox-group-props.js';
import '../checkbox/type.js';
import '../radio/radio.js';
import '../radio/props.js';
import '../radio/group.js';
import 'lodash/isNumber';
import '../radio/radio-group-props.js';
import '../radio/radio-button.js';
import '../radio/type.js';
import '../input/input.js';
import '../_common/js/utils/helper.js';
import 'lodash/isNull';
import '../input/props.js';
import '../input/input-group.js';
import '../input/type.js';
import '../button/button.js';
import '../loading/index.js';
import '../loading/directive.js';
import 'lodash/mapKeys';
import 'lodash/isEqual';
import '../loading/plugin.js';
import '../loading/loading.js';
import '../loading/icon/gradient.js';
import '../_common/js/loading/circle-adapter.js';
import '../utils/transfer-dom.js';
import '../loading/props.js';
import '../config.js';
import '../loading/type.js';
import '../button/props.js';
import '../utils/ripple.js';
import '../button/type.js';
import '../hooks/render-tnode.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var TableFilterController = defineComponent({
  name: "TableFilterController",
  props: {
    column: Object,
    colIndex: Number,
    tFilterValue: Object,
    innerFilterValue: Object,
    tableFilterClasses: Object,
    isFocusClass: String,
    primaryTableElement: {},
    popupProps: Object,
    attach: [String, Function]
  },
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var triggerElementRef = ref(null);
    var renderTNode = useTNodeDefault();
    var _useConfig = useConfig("table"),
      t = _useConfig.t,
      global = _useConfig.global;
    var _useGlobalIcon = useGlobalIcon({
        FilterIcon: FilterIcon
      }),
      FilterIcon$1 = _useGlobalIcon.FilterIcon;
    var filterPopupVisible = ref(false);
    var onFilterPopupVisibleChange = function onFilterPopupVisibleChange(visible) {
      filterPopupVisible.value = visible;
      emit("visible-change", visible);
    };
    return {
      t: t,
      global: global,
      FilterIcon: FilterIcon$1,
      filterPopupVisible: filterPopupVisible,
      triggerElementRef: triggerElementRef,
      renderTNode: renderTNode,
      onFilterPopupVisibleChange: onFilterPopupVisibleChange
    };
  },
  render: function render(h) {
    var _this = this,
      _this$tFilterValue;
    var getFilterContent = function getFilterContent(h2, column2) {
      var _column2$filter, _column2$filter2;
      var types = ["single", "multiple", "input"];
      if (column2.type && !types.includes(column2.filter.type)) {
        log.error("Table", "filter.type must be the following: ".concat(JSON.stringify(types)));
        return;
      }
      if (!column2.filter.type && !column2.filter.component) {
        log.error("Table", "both filter.type and filter.component can not be empty.");
        return;
      }
      var component = {
        single: RadioGroup,
        multiple: CheckboxGroup,
        input: Input
      }[column2.filter.type] || column2.filter.component;
      if (!component && !column2.filter.component) return;
      var filterComponentProps = _objectSpread({
        options: ["single", "multiple"].includes(column2.filter.type) ? (_column2$filter = column2.filter) === null || _column2$filter === void 0 ? void 0 : _column2$filter.list : void 0
      }, ((_column2$filter2 = column2.filter) === null || _column2$filter2 === void 0 ? void 0 : _column2$filter2.props) || {});
      if (column2.colKey && _this.innerFilterValue && column2.colKey in _this.innerFilterValue) {
        filterComponentProps.value = _this.innerFilterValue[column2.colKey];
      }
      var on = {
        change: function change(val) {
          _this.$emit("inner-filter-change", val, column2);
        }
      };
      if (column2.filter.confirmEvents) {
        column2.filter.confirmEvents.forEach(function (event) {
          var pureEvent = lowerFirst(event.replace("on", ""));
          on[pureEvent] = function () {
            _this.$emit("confirm", column2);
            _this.filterPopupVisible = false;
          };
        });
      }
      var wrapperListeners = {};
      if (column2.filter.showConfirmAndReset) {
        wrapperListeners.click = function (e) {
          return e.stopPropagation();
        };
      }
      var renderComponent = function renderComponent() {
        if (!component) return null;
        var isVueComponent = component.install && component.component;
        if (typeof component === "function" && !isVueComponent) {
          return component(function (v, b) {
            var attributes = _typeof(b) === "object" && "attrs" in b ? b.attrs : {};
            return h2(v, {
              props: _objectSpread({}, filterComponentProps),
              attrs: attributes,
              on: on
            });
          });
        }
        var filter = _this.column.filter || {};
        return h(component, helper([{}, {
          "attrs": filter.attrs
        }, {
          "class": filter.classNames,
          "style": filter.style
        }, {
          "props": _objectSpread({}, filterComponentProps)
        }, {}, {
          "on": _objectSpread({}, on)
        }]));
      };
      return h("div", helper([{
        "class": _this.tableFilterClasses.contentInner
      }, {
        "on": wrapperListeners
      }]), [renderComponent()]);
    };
    var getBottomButtons = function getBottomButtons(h2, column2) {
      if (!column2.filter.showConfirmAndReset) return;
      return h("div", {
        "class": _this.tableFilterClasses.bottomButtons
      }, [h(Button, {
        "attrs": {
          "theme": "default",
          "size": "small"
        },
        "on": {
          "click": function click() {
            _this.$emit("reset", column2);
            _this.filterPopupVisible = false;
          }
        }
      }, [_this.global.resetText]), h(Button, {
        "attrs": {
          "theme": "primary",
          "size": "small"
        },
        "on": {
          "click": function click() {
            _this.$emit("confirm", column2);
            _this.filterPopupVisible = false;
          }
        }
      }, [_this.global.confirmText])]);
    };
    var column = this.column,
      FilterIcon = this.FilterIcon,
      popupProps = this.popupProps;
    if (!column.filter || column.filter && !Object.keys(column.filter).length) return null;
    var defaultFilterIcon = this.t(this.global.filterIcon) || h(FilterIcon);
    var filterValue = (_this$tFilterValue = this.tFilterValue) === null || _this$tFilterValue === void 0 ? void 0 : _this$tFilterValue[column.colKey];
    var isObjectTrue = _typeof(filterValue) === "object" && !isEmpty(filterValue);
    var isValueExist = (filterValue || filterValue === false) && _typeof(filterValue) !== "object";
    return h(Popup, helper([{
      "attrs": {
        "attach": this.attach || (this.primaryTableElement ? function () {
          return _this.primaryTableElement;
        } : void 0),
        "visible": this.filterPopupVisible,
        "destroyOnClose": true,
        "trigger": "click",
        "placement": "bottom",
        "showArrow": true,
        "overlayClassName": this.tableFilterClasses.popup
      }
    }, {
      "on": {
        "visible-change": function visibleChange(val) {
          return _this.onFilterPopupVisibleChange(val);
        }
      }
    }, {
      "class": [this.tableFilterClasses.icon, _defineProperty({}, this.isFocusClass, isObjectTrue || isValueExist)],
      "attrs": {
        "content": function content() {
          return h("div", {
            "class": _this.tableFilterClasses.popupContent
          }, [getFilterContent(h, column), getBottomButtons(h, column)]);
        }
      }
    }, {
      "props": popupProps
    }]), [h("div", {
      "ref": "triggerElementRef"
    }, [this.renderTNode("filterIcon", {
      defaultNode: defaultFilterIcon,
      params: {
        col: column,
        colIndex: this.colIndex
      }
    })])]);
  }
});

export { TableFilterController as default };
//# sourceMappingURL=filter-controller.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-vue/es/table/filter-controller.js
// module id = null
// module chunks = 